const images = {
  social: '/assets/images/social.jpg',
  logo: '/assets/images/game_logo.webp',
  network_switch: '/assets/images/network_switch.webp',
  gene: '/assets/images/ic_gene.png',
  slime: '/assets/images/ic_slime.png',
};
const svgs = {
  listEmpty: '/assets/svgs/ic_list_empty.svg',
  land: '/assets/svgs/ic_land.svg',
  miningTool: '/assets/svgs/ic_mining_tool.svg',
  gachaBox: '/assets/svgs/ic_gacha_box.svg',
  toolMaterial: '/assets/svgs/ic_tool_material.svg',
  menu: '/assets/svgs/ic_menu.svg',
  filter: '/assets/svgs/ic_filter.svg',
  refresh: '/assets/svgs/ic_refresh.svg',
  metamask: '/assets/svgs/ic_metamask.svg',
  walletConnect: '/assets/svgs/ic_wallet_connect.svg',
  qrCode: '/assets/svgs/ic_qr_code.svg',
  statsAveragePrice: '/assets/svgs/ic_stats_average_price.svg',
  statsTotalNFTs: '/assets/svgs/ic_stats_total_nfts.svg',
  statsVolume: '/assets/svgs/ic_stats_volume.svg',
  statsTransaction: '/assets/svgs/ic_stats_transactions.svg',
};

const resouces = {
  images,
  svgs,
};

export default resouces;
